module.exports = __webpack_public_path__ + "static/media/maintenance.2df4ba2a.png";